import request from "@/utils/request";

/**
 * 添加对话详情
 * @param params
 * @param config
 * @returns {Promise<axios.AxiosResponse<any>>}
 */

export function addChatDetail(params, config) {
    return request.post('/gpt/mailAiUserConversationDetail/add', params, config)
}


/**
 * 获取对话详情 list
 */

export function getChatDetailList(params, config) {
    return request.get('/gpt/mailAiUserConversation/sessionPageList', params, config)
}


/**
 * 删除对话详情
 */

export function deleteChatDetail(params, config) {
    const {id} = params
    return request.delete(`/gpt/mailAiUserConversation/deleteSession?id=${id}`, params, config)
}

/**
 * 对话详情 detail
 */

export function queryChatById(params, config) {
    return request.get(`/gpt/mailAiUserConversation/getSessionDetail`, params, config)
}


/**
 * 建立会话
 */

export function createSession(params, config) {
    return request.post(`/gpt/mailAiUserConversation/createSession`, params, config)
}


/**
 * sse 数据流
 */

export function sendSSE(params, config) {
    return request.get(`/ai/chat/send`, params, config)
}


/**
 * 编辑详情
 */

export function aiDetailedit(params, config) {
    const {id, message} = params
    return request.put(`/gpt/mailAiUserConversation/updateSessionName?id=${id}&message=${message}`, params, config)
}

/**
 * 获取根节点 最新的一条数据
 */
export function getRootData(params, config) {
    return request.get(`/gpt/mailAiUserConversation/getLastDataByAssociateId`, params, config)
}

/**
 *
 */
export function closeAI(params, config) {
    return request.post(`/ai/chat/close`, params, config)
}

/**
 * 手动更新对话
 */
export function updateSession(params, config) {
    return request.get(`/ai/chat/updateSession`, params, config)
}